import React from 'react';
import { Translate } from 'react-localize-redux';
import { useLocalize } from '../../hooks';
import { GetTradingBlockSiteName } from '../../utilities/site';
export const Text = ({ id, type, page, textKey, data, defaultPage, siteGroup }) => {
    const { getTranslationId } = useLocalize();
    const defaultData = {
        ndash: '&ndash;',
        prefix: '',
        siteName: GetTradingBlockSiteName(undefined, siteGroup),
    };
    return (React.createElement(Translate, { id: getTranslationId({ id, type, page: defaultPage ? 'defaults' : page, textKey }), data: Object.assign({}, defaultData, data), options: {
            renderToStaticMarkup: false,
            onMissingTranslation: () => {
                return textKey;
            },
        } }));
};
//# sourceMappingURL=Text.js.map